<span *ngIf="durationValue">
  {{ durationValue }}
</span>
